module.exports = __webpack_public_path__ + "static/img/xc3.6458c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xc3.png
// module id = marF
// module chunks = 0